
export const FORM_PROPERTY_GROUP_BACKGROUNDS = 'Backgrounds'
export const FORM_PROPERTY_GROUP_BUTTON = 'Button'
export const FORM_PROPERTY_GROUP_FONT = 'Font'
export const FORM_PROPERTY_GROUP_HEADER = 'Header'

export const FORM_PROPERTY_GROUP_MESSAGING = 'Messaging'
export const FORM_PROPERTY_GROUP_METADATA = 'Metadata'

